<template>
  <div>
    <integration-detail-field class="mb-3" v-if="!editMode">
      <div slot="label">API Password:</div>
      <div slot="value">{{ integration.access_token }}</div>
    </integration-detail-field>
    <form-input v-else
                label="API Password"
                :value="form.access_token"
                :error="errors.access_token"
                @form-input="form.access_token = $event"></form-input>

    <integration-detail-field class="mb-3" v-if="!editMode">
      <div slot="label">Skill URL:</div>
      <div slot="value">{{ integration.workspace_url }}</div>
    </integration-detail-field>
    <form-input v-else
                label="Skill URL"
                :value="form.workspace_url"
                :error="errors.workspace_url"
                @form-input="form.workspace_url = $event"></form-input>

  </div>
</template>

<script>
  import IntegrationDetailField from '@/components/administration/common/Field'
  import 'vue-awesome/icons/external-link-alt'
  import FormInput from '@/components/administration/common/form/FormInput'

  export default {
    props: {
      editMode: Boolean,
      errors: {
        type: Object,
        default: () => ({})
      }
    },

    components: {
      'integration-detail-field': IntegrationDetailField,
      'form-input': FormInput
    },

    store: {
      integration: 'administration.integrationDetail.integration',
      form: 'administration.integrationDetail.integrationEdit.editableData'
    },

    watch: {
      editMode: function () {
        if (!this.editMode) return

        this.form.access_token = this.integration.access_token
        this.form.workspace_url = this.integration.workspace_url
      }
    }
  }
</script>
